import _get from "lodash/fp/get"

export function errorFormatter(error) {
  const errorMessage = _get("response.data.result", error) || _get("response.data.error", error) || _get("response.data.errors[0]", error)
  if (errorMessage) return errorMessage

  return error.message
}
